import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
  Modal,
  Checkbox,
} from "antd";
import signinLogo from "../../assets/images/Logo.svg";
import signinbg from "../../assets/images/login.svg";
import { ShowToast, Severty } from "../../helper/toast";
import { AuthContext } from "../../context/AuthContext";
import encryptDecrypt from "../../helper/encryptDecrypt";
import lang from "../../helper/langHelper";
import callApi from "../../constants/API/CallApi";
import { forgot, getLogging } from "../../constants/API/API";
import { emailDomainValidation } from "../../helper/functions";
import useNotificationPermission from "../../useNotificationPermission";
const { Title } = Typography;
const { Content } = Layout;

const SignIn = () => {
  const { token: fcmToken } = useNotificationPermission();
  useEffect(() => {
    const userToken = localStorage.getItem("token");
    if (userToken) {
      navigate("/dashboard");
      window.location.reload();
    }
  }, []);
  const { setIsLoggedIn, setUserProfile } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  const [selected, setSelected] = useState();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  console.log({ fcmToken });

  const [rememberMe, setRememberMe] = useState(false);

  const handleRememberMeChange = (checked) => {
    setRememberMe(checked);
  };

  const onFinish = (values) => {
    onSubmit(values);
  };

  const onSubmit = (values) => {
    const { email, password } = values;

    if (!email)
      return ShowToast("Please enter email to sign in", Severty.ERROR);

    const payload = {
      password,
      fcmToken: fcmToken,
    };
    if (!email) return ShowToast("Please enter valid email ", Severty.ERROR);
    setLoading(true);
    payload.email = email;
    callApi({
      callback: getLogging,
      payload,
      onSuccess: (data) => {
        setLoading(false);
        setIsLoggedIn(true);
        if (rememberMe?.target?.checked === true || rememberMe === true) {
          // Store the login state in local storage
          var emailEncrypt = encryptDecrypt.encryptEmail(values.email);
          var passwordEncrypt = encryptDecrypt.encryptPassword(values.password);
          localStorage.setItem("rememberMe", true);
          localStorage.setItem("ykmCe2AYEFTHobn", emailEncrypt);
          localStorage.setItem("ouUsippetc8S4Ry", passwordEncrypt);
        } else {
          localStorage.removeItem("rememberMe");
          localStorage.removeItem("ykmCe2AYEFTHobn");
          localStorage.removeItem("ouUsippetc8S4Ry");
        }
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("userProfile", JSON.stringify(data?.data?.user ?? {}));
        localStorage.setItem("permission",
          JSON.stringify(data.data?.permission??{})
        );
        ShowToast(data.message, Severty.SUCCESS);
        setUserProfile(data.data.user);
        window.location.replace("/dashboard");
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleForgotPassword = () => {
    setVisible(true);
  };

  const handleResetPassword = (email) => {
    // Send the OTP to the user's email
    setResetLoading(true);
    let payload = {};
    payload.email = email.email;
    callApi({
      callback: forgot,
      payload,
      onSuccess: (data) => {
        setResetLoading(false);
        setVisible(false);
        ShowToast(data.message, Severty.SUCCESS);
      },
      onError: (error) => {
        setResetLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleCancelReset = () => {
    setResetModal(false);
    // form.resetFields()
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem("ykmCe2AYEFTHobn");
    const savedPassword = localStorage.getItem("ouUsippetc8S4Ry");

    if (savedEmail && savedPassword) {
      var originalEmail = encryptDecrypt.decryptEmail(savedEmail);
      var originalPassword = encryptDecrypt.decryptEmail(savedPassword);

      form.setFieldsValue({
        email: originalEmail,
        password: originalPassword,
        remember: true,
      });
      setRememberMe(true);
    } else {
      setRememberMe(false);
    }
  }, []);

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <Row>
            <Col span={24} lg={12} xl={15} xxl={16} className="signin-bg">
              <div className="signin_img">{/* <img src={signinbg} /> */}</div>
            </Col>
            <Col span={24} lg={12} xl={9} xxl={8}>
              <div className="signin-box">
                <div className="signup-logo">
                  <img src={signinLogo} alt="" />
                </div>
                <Row justify="space-around">
                  <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                    <div className="signup-form">
                      <Title className="mb-15">
                        {lang("Login to your Account Admin")}
                      </Title>
                      <Title className="font-regular text-muted" level={5}>
                        {lang("See what is going on with your business")}
                      </Title>
                      <Form
                        form={form}
                        onFinish={() => console.lo("dd")}
                        onFinishFailed={onFinishFailed}
                        layout="vertical"
                        className="row-col"
                      >
                        {/* <Form.Item label={"Login As"}>
                          <Select
                            defaultValue="Admin"
                            options={[
                              { value: "Admin", label: "Admin" },
                              // { value: "Vendor", label: "Vendor" },
                              { value: "Super Admin", label: "Super Admin" },
                            ]}
                          />
                        </Form.Item> */}
                        <Form.Item
                          className="username"
                          label={lang("Email Address")}
                          name="email"
                          rules={[
                            {
                              type: "email",
                              message: lang(
                                "Please enter a valid email address!"
                              ),
                            },
                            {
                              max: 255,
                              message: lang(
                                "Email address not more then 255 characters!"
                              ),
                            },
                            {
                              required: true,
                              message: lang("Please enter your email!"),
                            },
                            // emailDomainValidation,
                          ]}
                        >
                          <Input placeholder={lang("Enter Email Address")} />
                        </Form.Item>
                        <Form.Item
                          className="password"
                          label={lang("Password")}
                          name="password"
                          rules={[
                            {
                              required: true,
                              validator: (_, value) => {
                                if (!value) {
                                  return Promise.reject(
                                    new Error("Please enter your password!")
                                  );
                                }
                                // if (value.length < 8) {
                                //   return Promise.reject(
                                //     new Error(
                                //       "Password must be at least 8 characters."
                                //     )
                                //   );
                                // }
                                // if (value.length > 15) {
                                //   return Promise.reject(
                                //     new Error(
                                //       "Password must be at most 15 characters."
                                //     )
                                //   );
                                // }
                                // if (!/[a-z]/.test(value)) {
                                //   return Promise.reject(
                                //     new Error(
                                //       "Password must contain at least one lowercase letter."
                                //     )
                                //   );
                                // }
                                // if (!/[A-Z]/.test(value)) {
                                //   return Promise.reject(
                                //     new Error(
                                //       "Password must contain at least one uppercase letter."
                                //     )
                                //   );
                                // }
                                // if (!/\d/.test(value)) {
                                //   return Promise.reject(
                                //     new Error(
                                //       "Password must contain at least one number."
                                //     )
                                //   );
                                // }
                                // if (!/[^a-zA-Z0-9]/.test(value)) {

                                //   return Promise.reject(
                                //     new Error(
                                //       "Password must contain at least one special character."
                                //     )
                                //   );
                                // }
                                // return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input.Password
                            onCut={(e) => e.preventDefault()}
                            onCopy={(e) => e.preventDefault()}
                            onPaste={(e) => e.preventDefault()}
                            autoComplete="off"
                            placeholder={lang("Enter Password")}
                          />
                        </Form.Item>

                        <div className="forgot-pass">
                          <Form.Item
                            name="remember"
                            className="aligin-center"
                            valuePropName="checked"
                          >
                            <Checkbox
                              checked={rememberMe}
                              onChange={handleRememberMeChange}
                            >
                              {lang("Remember me")}
                            </Checkbox>
                          </Form.Item>
                          <Form.Item
                            name="remember"
                            className="aligin-center"
                            valuePropName="checked"
                          >
                            <a onClick={handleForgotPassword}>
                              <a>{lang("Forgot Password?")}</a>
                            </a>
                          </Form.Item>
                        </div>
                        <Form.Item>
                          <Button
                            className="float-right"
                            type="primary"
                            htmlType="submit"
                            onClick={() => onFinish(form.getFieldsValue())}
                          // loading={loading}
                          >
                            {lang("Login")}
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Content>

        {visible ? (
          <Modal
            open={visible}
            // title="Forgot Password"
            okText={lang("Send Reset Link")}
            onCancel={() => {
              setVisible(false);
              // form.resetFields()
            }}
            className="tab_modal"
            okButtonProps={{
              form: "forget-pasword",
              htmlType: "submit",
              loading: resetLoading,
            }}
          >
            <h4 className="modal_title_cls">{lang("Forgot Password")}</h4>
            <Form
              id="forget-pasword"
              onFinish={handleResetPassword}
              layout="vertical"
            >
              <Form.Item
                label={lang("Email Address")}
                name="email"
                rules={[
                  {
                    type: "email",
                    message: lang("Please enter a valid email address!"),
                  },
                  {
                    max: 255,
                    message: lang(
                      "Email address not more then 255 characters!"
                    ),
                  },
                  {
                    required: true,
                    message: lang("Please enter your email!"),
                  },
                  // emailDomainValidation,
                ]}
              >
                <Input
                  autoComplete="off"
                  placeholder={lang("Enter Email Address")}
                />
              </Form.Item>
            </Form>
          </Modal>
        ) : null}

        {otpModal ? (
          <Modal
            open={otpModal}
            // title="Verify OTP"
            okText={lang("Verify")}
            onCancel={(e) => {
              setOtpModal(false);
              // form.resetFields()
            }}
            className="tab_modal"
            okButtonProps={{
              form: "verify-otp",
              htmlType: "submit",
              loading: verifyLoading,
            }}
          >
            <h4 className="modal_title_cls">{lang("Verify OTP")}</h4>
            <Form
              id="verify-otp"
              onFinish={(e) => console.log(e)}
              layout="vertical"
            >
              <Form.Item
                label={lang("OTP")}
                name="otp"
                rules={[
                  {
                    required: true,
                    message: lang("Please enter the OTP"),
                  },
                  {
                    len: 4,
                    message: lang("OTP must be 4 digits"),
                  },
                ]}
              >
                <Input
                  autoComplete="off"
                  type="number"
                  maxLength={4}
                  placeholder={lang("Enter OTP")}
                />
              </Form.Item>
            </Form>
          </Modal>
        ) : null}

        {resetModal ? (
          <Modal
            open={resetModal}
            // title="Reset Password"
            okText={lang("Update Password")}
            onCancel={handleCancelReset}
            okButtonProps={{
              form: "reset-password",
              htmlType: "submit",
              loading: passwordLoading,
            }}
            className="tab_modal"
          >
            <h4 className="modal_title_cls">{lang("Reset Password")}</h4>
            <Form
              id="reset-password"
              onFinish={(e) => console.log(e)}
              layout="vertical"
            >
              <Form.Item
                label={lang("New Password")}
                name="newPassword"
                rules={[
                  {
                    required: true,
                    message: lang("Please enter your new password!"),
                  },
                  {
                    pattern: new RegExp(
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
                    ),
                    message: lang(
                      "New password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character"
                    ),
                  },
                ]}
              >
                <Input.Password placeholder={lang("Enter New Password")} />
              </Form.Item>
              <Form.Item
                label={lang("Confirm New Password")}
                name="confirm_new_password"
                dependencies={["newPassword"]}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: lang("Please enter the confirm password!"),
                  },
                  {
                    pattern: new RegExp(
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
                    ),
                    message:
                      "Confirm password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("newPassword") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          lang("Password that you entered doesn't match!")
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password placeholder={lang("Enter Confirm Password")} />
              </Form.Item>
            </Form>
          </Modal>
        ) : null}
      </Layout>
    </>
  );
};

export default SignIn;
